import React from 'react'
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography
} from '@mui/material'
import { rxOpenAlert } from '../lib/rx_subject'

const Alert = () => {
  const [open, setOpen] = React.useState(false)
  const [alert, setAlert] = React.useState({})

  React.useEffect(() => {
    const subscription = rxOpenAlert.subscribe(alert => {
      setAlert(alert)
      setOpen(true)
    })

    return () => {
      subscription.unsubscribe()
    }
  }, [])

  const close = () => {
    setOpen(false)
  }

  return (
    <Dialog className="alert-dialog" open={open}
            aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">{alert.title}</DialogTitle>
      <DialogContent>
        <Typography className="message">
          {alert.message}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button className="close" color="secondary" onClick={close}>
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default Alert
